<template>
  <b-dropdown
    menu-class="p-0 state-options-dropdown custom-width-fix"
    lazy
    :disabled="disabled"
    ref="baseDropdown"
  >
    <template #button-content>
      <strong
        class="flex-grow-1 text-left"
      >{{ capitalizeFirstLetter(filter) }}</strong>
      <span class="ml-5">({{ selectedOptions.length }}/{{ alphabeticallySortedList.length }})</span>
    </template>
    <b-dropdown-form class="dropdown-options bg-light p-2 w-100">
      <small> <b-link @click="selectAll">Select all</b-link> / <b-link @click="deselectAll">Deselect all</b-link></small>
    </b-dropdown-form>
    <b-dropdown-form
      class="p-0"
      v-for="(option, index) in alphabeticallySortedList"
      :key="index"
    >
      <b-form-checkbox
        :id="`${filter}-checkbox-${option[keyProperty]}`"
        :name="`${filter}-checkbox-${option[keyProperty]}`"
        :checked="selectedOptions.includes(option[keyProperty])"
        @change="toggleOptionSelection(option[keyProperty], $event)"
        size="xl"
        class="option-checkbox"
        :data-test="`${filter}-list-item-checkbox`"
      >
        {{ option[valueProperty] }}
      </b-form-checkbox>
    </b-dropdown-form>
    <div class="d-flex justify-content-center p-2 border-top bg-light">
      <b-button
        variant="primary"
        size="sm"
        @click="applyFilters"
      >
        Apply
      </b-button>
    </div>
  </b-dropdown>
</template>
<script>
import textHelper from '@/core/mixins/textHelper';

export default {
  name: 'BaseFilterDropdown',
  mixins: [
    textHelper,
  ],
  props: {
    filter: {
      type: String,
      required: true,
      default: '',
    },
    optionsList: {
      type: Array,
      required: true,
      default: () => [],
    },
    keyProperty: {
      type: String,
      required: true,
      default: 'id',
    },
    valueProperty: {
      type: String,
      required: true,
      default: 'name',
    },
    selectedOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    alphabeticallySortedList() {
      if (this.optionsList.length === 0) return [];
      return this.sortListAlphabetically(this.optionsList, this.valueProperty);
    },
  },
  methods: {
    sortListAlphabetically(list, prop) {
      return list.sort((a, b) => {
        if (a[prop] < b[prop]) { return -1; }
        if (a[prop] > b[prop]) { return 1; }
        return 0;
      });
    },
    toggleOptionSelection(keyProperty, isChecked) {
      this.$emit('updatedSelectedOptions', keyProperty, isChecked);
    },
    selectAll() {
      this.$emit('selectAllOptions');
    },
    deselectAll() {
      this.$emit('deselectAllOptions');
    },
    applyFilters() {
      this.$emit('applyStatesFilters');
      this.$refs.baseDropdown.hide();
    },
  },
};
</script>
<style lang="scss">
.dropdown {
  position: relative;
}
button.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dropdown-options {
  text-align: center;
  padding-bottom: 3px;
}
.state-options-dropdown {
  height: auto;
  max-height: 400px;

  width: 100% !important;
  min-width: 100% !important;
  margin-top: 2px !important;
  left: 0 !important;
  right: 0 !important;
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 4px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
  overflow-y: auto;

  form.b-dropdown-form {
    padding: 0 !important;
    margin: 0 !important;
  }

  .option-checkbox {
    width: 100% !important;
    padding: 10px 15px 10px 40px !important;
    display: block !important;
    transition: background 0.1s ease;

    &:hover {
      background-color: #f8f9fa;
    }

    .custom-control-label {
      width: 100%;
      cursor: pointer;
      font-size: 14px;
      color: #333;
    }

    .custom-control-input {
      left: 15px !important;
    }
  }
}
</style>
